import "./App.css";

import { BrowserRouter, Route, Routes, useNavigate, useSearchParams } from "react-router-dom";
import { ChakraProvider, useToast } from "@chakra-ui/react";
import { useEffect } from "react";

import { JourneyContextProvider, useJourneyContext } from "./hooks/useJourney";
import { useMetadata } from "./hooks/useMetadata";

import LandingPage from "./Screens/LandingPage";
import AddBookingPage from "./Screens/AddBookingPage/";
import UpdateBookingPage from "./Screens/UpdateBookingPage/";
import BookingConfirmed from "./Screens/BookingConfirmed/BookingConfirmed";

/**
 * AppContent component handles metadata-aware navigation
 */
const AppContent = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const toast = useToast();
  const { data: metadata, error: metadataError } = useMetadata();

  useEffect(() => {
    const preRegToken = searchParams.get("meta");
    
    // Only process if we have a meta param
    if (!preRegToken) {
      return;
    }

    // Handle metadata error - show toast and redirect to landing
    if (metadataError) {
      navigate("/", { replace: true });
      return;
    }

    // Check if metadata was successfully loaded
    if (metadata) {
      const hasAllRequiredFields =
        metadata.customerFirstName &&
        metadata.customerLastName &&
        metadata.phoneNumber &&
        metadata.emailAddress;

      if (hasAllRequiredFields) {
        // All fields are prefilled - skip landing page and go straight to booking
        navigate("/add-booking", {
          replace: true,
          state: { ...metadata, preRegToken, },
        });
      } else {
        // Some fields are prefilled - go to landing with prefilled data
        navigate("/", {
          replace: true,
          state: { ...metadata, preRegToken, },
        });
      }
    }
  }, [metadata, metadataError, searchParams, navigate, toast]);

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/add-booking" element={<AddBookingPage />} />
      <Route path="/update-booking" element={<UpdateBookingPage />} />
      <Route path="*" element={<LandingPage />} />
      <Route path="/booking-confirmed" element={<BookingConfirmed />} />
    </Routes>
  );
};

const App = () => {
  return (
    <ChakraProvider>
      <BrowserRouter>
        <JourneyContextProvider>
          <AppContent />
        </JourneyContextProvider>
      </BrowserRouter>
    </ChakraProvider>
  );
};

export default App;
